import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import TextButton from 'LuxKit/Button/TextButton'
import Pill from 'LuxKit/Pill'
import Heading from 'LuxKit/Typography/Heading'
import TextLink from 'LuxKit/TextLink'
import { LUXURY_PLUS, LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'
import useJoinLuxPlusFreePreview from 'luxPlus/hooks/useJoinLuxPlusFreePreview'

function LuxPlusFreePreviewCtaSection() {
  const intl = useIntl()
  const {
    onPendingJoinFreePreview,
    hasInviteExpiryDate,
    formattedExpiryDate,
    invitePillExpiryCopy,
  } = useJoinLuxPlusFreePreview()

  const expiryMessage = hasInviteExpiryDate ? intl.formatMessage(
    {
      id: 'v63BV0yU7p0XeVDUvjAF',
      defaultMessage: 'This exclusive invite is only valid until {date}.',
      description: 'Expiry date notice for LuxPlus+ free preview invitation',
    },
    { date: formattedExpiryDate },
  ) : ''

  const headingText = intl.formatMessage(
    {
      id: 'jPVm8QTHOB9k-cZEpMQA',
      defaultMessage: '{duration}-day Free Preview',
      description: 'Heading for LuxPlus+ free preview call-to-action section',
    },
    { duration: LUXURY_PLUS.FREE_PREVIEW_DURATION },
  )

  const startPreviewText = intl.formatMessage({
    id: 'kolaRPWydoCz72mMqCLI',
    defaultMessage: 'Start Free Preview now',
    description: 'Action button label to start the LuxPlus+ free preview',
  })

  return <Pane paletteType="default" data-testid="lux-plus-free-preview-cta-section">
    <PaneBody size="md">
      <VerticalSpacer gap={16}>
        <VerticalSpacer gap={8}>
          <Pill
            endIcon={null}
            kind="primary"
            startIcon={null}
            variant="success"
          >
            {invitePillExpiryCopy}
          </Pill>
          <Heading variant="heading3">{headingText}</Heading>
          <BodyText variant="medium" colour="primary-dark">
            <FormattedMessage
              id="CA2Zo7udmz_MLIrMgbEr"
              defaultMessage="Discover hidden offers, view member pricing and find out what life is like in our VIP Travel Club. {expiryMessage} <bold>No credit card required!</bold>"
              description="Body text describing benefits of the LuxPlus+ free preview with optional expiry date"
              values={{
                expiryMessage,
                bold: (chunks: React.ReactNode) => <b>{chunks}</b>,
              }}
            />
          </BodyText>
        </VerticalSpacer>
        <TextButton kind="primary" fit="full-width" onClick={onPendingJoinFreePreview}>{startPreviewText}</TextButton>
        <BodyText variant="small">
          <FormattedMessage
            id="71u8TKsjv4jSr2t0lL8c"
            defaultMessage="To book an offer with {brandName} benefits during your Free Preview you will be prompted to become a member. <link>T&Cs apply.</link>"
            description="Disclaimer about requiring LuxPlus+ membership to book with free preview benefits, with terms and conditions link"
            values={{
              brandName: 'LuxPlus+',
              link: (chunks: React.ReactNode) => <TextLink weight="regular" to={`/${LUXURY_PLUS_PATHS.TERMS_AND_CONDITIONS_PAGE}`}>{chunks}</TextLink>,
            }}
          />
        </BodyText>
      </VerticalSpacer>
    </PaneBody>
  </Pane>
}

export default LuxPlusFreePreviewCtaSection
